import { connect } from "react-redux";
import { toggleRemoveDraft } from "your_projects/ducks";
import DraftProjects from "your_projects/components/draft_projects";

export default connect(() => ({}), {
  toggleRemoveModal: toggleRemoveDraft,
})(DraftProjects);
